import { Banner } from '@raysee/schema';
import firebase from 'firebase';

export class BannerRepository {
  findWithoutSubscRetargetAttributes = async (orderType: 'asc' | 'desc'): Promise<Banner[]> => {
    try {
      const docSnap = await firebase
        .firestore()
        .collection('banners')
        .orderBy('createTime', orderType)
        .get();
      return docSnap.docs
        .map(
          (doc) =>
            ({
              ...doc.data(),
              startTime: doc.data().startTime?.toDate(),
              endTime: doc.data().endTime?.toDate(),
              createTime: doc.data().createTime.toDate(),
              updateTime: doc.data().updateTime.toDate(),
            }) as Banner,
        )
        .filter(
          // subscRetargetAttributesが空配列またはundefinedのバナーを取得
          (banner) => !(banner.subscRetargetAttributes?.length > 0),
        );
    } catch (e) {
      throw new Error(e);
    }
  };

  findWithoutGuestLimited = async (orderType: 'asc' | 'desc'): Promise<Banner[]> => {
    try {
      const docSnap = await firebase
        .firestore()
        .collection('banners')
        .where('isGuestLimited', '==', false)
        .orderBy('createTime', orderType)
        .get();
      return docSnap.docs.map(
        (doc) =>
          ({
            ...doc.data(),
            startTime: doc.data().startTime?.toDate(),
            endTime: doc.data().endTime?.toDate(),
            createTime: doc.data().createTime.toDate(),
            updateTime: doc.data().updateTime.toDate(),
          }) as Banner,
      );
    } catch (e) {
      throw new Error(e);
    }
  };
}
